var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"product_banner",style:({backgroundImage:'url('+_vm.backgroundImage+')'})},[_c('div',{staticClass:"banner_mark"},[_c('div',{staticClass:"banner_title animate__animated animate__bounce"},[_vm._v(_vm._s(_vm.title))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }